import { createFileRoute } from '@tanstack/react-router';

import { getRouteHead } from '~/app/routeHead';
import Game from '~/game/Game';

export const Route = createFileRoute('/freegame')({
  component: Game,
  head: () => getRouteHead({ title: 'Free game' }),
});
